import { z } from 'zod';

export const factionSchema = z.enum(['equestria', 'interdef']);
export type Faction = z.infer<typeof factionSchema>;
export const modeSchema = z.enum(['sector_control', 'annihilation']);
export type GameMode = z.infer<typeof modeSchema>;
export const categorySchema = z.enum(['infantry', 'vehicle', 'air', 'drone', 'building']);
export type UnitCategory = z.infer<typeof categorySchema>;

export const unitSchema = z.object({
  id: z.string().regex(/^[a-z0-9_]+$/),
  faction: factionSchema,
  name: z.string(),
  source: z.string(),
  category: categorySchema,
  cost: z.number().positive(),
  requestTime: z.number().positive(),
  capacity: z.number().int().positive(),
  health: z.number().positive(),
  speed: z.number().positive(),
  range: z.number().nonnegative(),
  damage: z.number().nonnegative(),
  armor: z.number().nonnegative(),
  members: z.number().int().positive().optional(),
  air: z.boolean().optional(),
  antiAir: z.boolean().optional(),
  role: z.string(),
  abilities: z.array(z.string()),
});
export type UnitDefinition = z.infer<typeof unitSchema>;

export interface BuildingDefinition {
  id: string;
  faction: Faction;
  name: string;
  cost: number;
  buildTime: number;
  prerequisites: string[];
  unlocks: string[];
}

export interface SectorDefinition {
  id: string;
  name: string;
  type: 'base' | 'supply' | 'victory' | 'connector';
  point: { x: number; y: number };
  neighbors: string[];
  initialOwner?: Faction;
}
